import * as yup from "yup"
import { Tavola } from "../../types"

export function initialValuesTavola(tavola?: Tavola | undefined) {
  if (tavola) {
    return tavola
  }
  return {
    titolo: "",
    sottotitolo: "",
    descrizione: "",
    ubicazione: "",
    atlante: undefined,
    numero_canto: undefined,
  }
}

export function validationSchemaTavola(hasAtalante: boolean = false) {
  const shape = {
    titolo: yup.string().required("Campo obbligatorio"),
  }
  if (hasAtalante) {
    Object.assign(shape, {
      atlante: yup.number().required("Campo obbligatorio"),
    })
  }
  return yup.object().shape(shape)
}
